import { Plus, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import { Label } from '../ui/label';
import {
  Dialog, DialogContent, DialogDescription, DialogHeader,
  DialogTitle, DialogFooter,
} from '../ui/dialog';

export function AddAnotherSongDialog({
  addAnotherItem, setAddAnotherItem,
  addAnotherTitle, setAddAnotherTitle,
  addAnotherMessage, setAddAnotherMessage,
  handleAddAnother, addingAnother,
}) {
  return (
    <Dialog open={!!addAnotherItem} onOpenChange={(open) => !open && setAddAnotherItem(null)}>
      <DialogContent className="bg-surface border-[#262626] max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Plus className="w-5 h-5 text-lime" />
            Add Another Song from {addAnotherItem?.artist_name}
          </DialogTitle>
          <DialogDescription>
            Price: ${addAnotherItem?.price?.toFixed(2)}
          </DialogDescription>
        </DialogHeader>
        <div className="py-4 space-y-4">
          <div>
            <Label htmlFor="add-another-song-title" className="text-sm text-[#A1A1AA] mb-2 block">Song Title</Label>
            <Input
              id="add-another-song-title"
              value={addAnotherTitle}
              onChange={(e) => setAddAnotherTitle(e.target.value)}
              placeholder="Enter the song title here"
              className="input-dark"
              maxLength={120}
              data-testid="add-another-title"
            />
          </div>
          <div>
            <Label htmlFor="add-another-message" className="text-sm text-[#A1A1AA] mb-2 block">Custom Dubplate Message</Label>
            <Textarea
              id="add-another-message"
              value={addAnotherMessage}
              onChange={(e) => setAddAnotherMessage(e.target.value)}
              placeholder="e.g., Shout out to my crew, big up the soundsystem..."
              className="min-h-[120px] input-dark"
              maxLength={500}
              data-testid="add-another-message"
            />
            <p className="text-xs text-[#666] mt-1">{addAnotherMessage.length}/500 characters</p>
          </div>
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={() => setAddAnotherItem(null)}>Cancel</Button>
          <Button
            onClick={handleAddAnother}
            disabled={addingAnother || !addAnotherMessage.trim() || !addAnotherTitle.trim()}
            className="btn-primary"
            data-testid="confirm-add-another-btn"
          >
            {addingAnother ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Plus className="w-4 h-4 mr-2" />}
            Add to Cart
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
